import { useEffect, useRef } from "react";
// import { ImageOverlay } from "./ImageOverlay";
import "./imageOverlay.css";

export function useImageOverlay({
  mode,
  map,
  imageSrc,
  initialNW,
  initialSE,
  initialRotate,
  onBoundsChanged,
  // mapReady,
}) {
  const overlayRef = useRef(null);

  useEffect(() => {
    console.log("useImageOverlay effect", {
      mode,
      map,
      imageSrc,
      initialNW,
      initialSE,
      initialRotate,
      overlayRef: overlayRef.current,
    });
    if (!mode) return;
    if (!map) return;
    if (!imageSrc) return;
    if (!initialNW || !initialSE) return;
    if (initialRotate == null) return; // ✅ allows 0
    if (overlayRef.current) return;

    let cancelled = false;

    (async () => {
      if (!window.google || !window.google.maps) {
        throw new Error("Google Maps JavaScript API not loaded");
      }

      let { ImageOverlay } = await import("./ImageOverlay");
      if (cancelled) return;

      overlayRef.current = new ImageOverlay({
        mode,
        map,
        imageSrc,
        initialNW: initialNW,
        initialSE: initialSE,
        initialRotate: initialRotate,
        onBoundsChanged,
      });

      console.log(
        "%cImageOverlay mounted",
        "color: green;",
        overlayRef.current
      );
    })();

    return () => {
      cancelled = true;
      console.log(
        "%cImageOverlay unmounted",
        "color: red;",
        overlayRef.current
      );
      overlayRef.current?.setMap(null);
      overlayRef.current = null;
    };
  }, [
    mode,
    map,
    imageSrc,
    initialNW,
    initialSE,
    initialRotate,
    onBoundsChanged,
  ]);

  return overlayRef;
}
